import Skeleton from "../skeleton/Skeleton";
import Thumbnail from "../skeleton/Thumbnail";
import Text from "../skeleton/Text";

const ProductSkeleton = () => {
  return (
    <div className="product-grid product-skeleton-grid">
      {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
        <div className="product-skeleton-card" key={item}>
          <Skeleton>
            <Thumbnail height="260px" />
            <Text mt="12px" />
            <Text mt="10px" />
          </Skeleton>
        </div>
      ))}
    </div>
  );
};

export default ProductSkeleton;
